
export const features = {
  'features.digitalProfiles': 'Profils Numériques des Fermes',
  'features.digitalProfilesDesc': 'Créez des profils numériques complets pour chaque ferme, en suivant toutes les informations pertinentes en un seul endroit.',
  'features.subsidyMatching': 'Correspondance de Subventions',
  'features.subsidyMatchingDesc': 'Associez automatiquement les fermes aux subventions et aides disponibles en fonction de leurs profils et activités.',
  'features.applicationTracking': 'Suivi des Demandes',
  'features.applicationTrackingDesc': 'Gérez l\'ensemble du processus de demande de subvention, de la rédaction à la soumission et à l\'approbation.',
} as const;
